import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ChevronDown_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.2526 7.33564C2.61952 6.92285 3.25159 6.88567 3.66437 7.25259L12 14.662L20.3356 7.25259C20.7484 6.88567 21.3805 6.92285 21.7474 7.33564C22.1143 7.74842 22.0772 8.38049 21.6644 8.74741L12.6644 16.7474C12.2855 17.0842 11.7145 17.0842 11.3356 16.7474L2.33565 8.74741C1.92286 8.38049 1.88568 7.74842 2.2526 7.33564Z"
            />
        </SvgStyled>
    );
};

export default ChevronDown_md;
